import { makeStyles } from "tss-react/mui";
import ColourConstants from "helpers/colourConstants";

const ROW_DIVIDER_COLOUR = "rgba(224, 224, 224, 1)";

const useModelTaskTableStyles = makeStyles()(() => ({
	table: {
		borderStyle: "solid",
		borderColor: ColourConstants.tableBorder,
		borderWidth: 1,
		borderRadius: 0,
		fontFamily: "Roboto Condensed",
		fontSize: 14,
		overflowX: "auto",
	},
	tableHeadRow: {
		borderBottomColor: ColourConstants.tableBorder,
		borderBottomStyle: "solid",
		borderBottomWidth: 1,
		backgroundColor: ColourConstants.tableBackground,
		fontWeight: "bold",
		borderRightColor: "#979797",
		borderRightStyle: "solid",
		borderRightWidth: "1px",
	},
	selectedTableHeadRow: {
		borderBottomColor: ColourConstants.tableBorder,
		borderBottomStyle: "solid",
		borderBottomWidth: 1,
		backgroundColor: ColourConstants.tableBackgroundSelected,
		color: "#FFFFFF",
		fontWeight: "bold",
	},
	nameRow: { width: "200px", height: "10px", lineHeight: "1rem" },
	dataCell: { height: 40 },
	statusCell: { padding: 12, textAlign: "center" },
	// Drawn as a shadow, not a border: the expanded row collapses to zero height,
	// so its `border-bottom: hidden` wins the border-collapse conflict and erases
	// any real border on the adjoining edge.
	rowDivider: { boxShadow: `inset 0 -1px 0 ${ROW_DIVIDER_COLOUR}` },
	// One treatment for every full-width action row: Go to Top, Load previous,
	// and the retry rows. They all read as the same affordance.
	tableAction: {
		cursor: "pointer",
		color: ColourConstants.activeLink,
		fontFamily: "Roboto Condensed",
		fontWeight: "bold",
		fontSize: 15,
		textAlign: "center",
		verticalAlign: "middle",
		"&:hover": { backgroundColor: ColourConstants.hoverGrey },
	},
	// Same row, nothing to click yet.
	tableActionBusy: {
		color: ColourConstants.commonText,
		fontFamily: "Roboto Condensed",
		fontSize: 15,
		textAlign: "center",
		verticalAlign: "middle",
	},
}));

export default useModelTaskTableStyles;
